<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="form-title tw-relative tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center ">
            </div>
            <fieldset class="tw-px-3 tw-pb-3 tw-pt-4 lg:tw-pt-8 lg:tw-px-5 lg:tw-pb-12">
                <div class="question" v-if="formStep === 1">A vaga Grátis é para si?</div>
                <div class="question" v-if="formStep === 2">Tem dificuldades em perceber algumas palavras?</div>
                <div class="question" v-if="formStep === 3">Quer saber o local perto de si?</div>
                <div class="question" v-if="formStep === 4">Preencha para saber tudo!</div>
                <div class="step" v-if="formStep === 1">
                    <div class="options">
                        <div @click="formStep++">Sim</div>
                        <div @click="formStep++">Não</div>
                    </div>
                </div>
                <div class="step" v-if="formStep === 2">
                    <div class="options">
                        <div @click="formStep++">Sim</div>
                        <div @click="formStep++">Não</div>
                    </div>
                </div>
                <div class="step" v-if="formStep === 3">
                    <div class="options">
                        <div @click="formStep++">Sim</div>
                        <div @click="formStep++">Não</div>
                    </div>
                </div>
                <div class="step tw-px-5 lg:tw-px-0" v-if="formStep === 4">
                    <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-8">
                        <validation-provider class="tw-w-full tw-w-block" name="fullName" rules="required|alpha_spaces" v-slot="{ classes }">
                            <div class="input-group input-group-name" :class="classes">
                                <input type="text"
                                    id="input-fullName"
                                    placeholder=" "
                                    v-model="fullName"
                                >
                                <label>
                                    Nome e Apelido
                                </label>
                            </div>
                        </validation-provider>
                        <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:pt" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', phone: ' ' }">
                            <div class="input-group input-group-phone" :class="classes">
                                <input type="tel"
                                    id="input-phone"
                                    placeholder=" "
                                    v-model="phone"
                                    v-mask="{mask: '999999999', placeholder:' '}"
                                >
                                <label>
                                    Telefone {{ errors [0]}}
                                </label>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-8">
                        <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'inválido' }">
                            <div class="input-group input-group-email" :class="classes">
                                <input type="email"
                                    id="input-email"
                                    placeholder=" "
                                    v-model.lazy="email"
                                >
                                <label>
                                    Email {{ errors [0]}}
                                </label>
                            </div>
                        </validation-provider>
                        <validation-provider class="tw-w-full tw-w-block" name="city" rules="required" v-slot="{ classes }">
                            <div class="input-group input-group-city" :class="classes">
                                <select id="input-city" v-model="city">
                                    <option disabled selected value=""></option>
                                    <option value="Abrantes">Abrantes</option>
                                    <option value="&Aacute;gueda">&Aacute;gueda</option>
                                    <option value="Aguiar Da Beira">Aguiar Da Beira</option>
                                    <option value="Alandroal">Alandroal</option>
                                    <option value="Albergaria-a-velha">Albergaria-a-velha</option>
                                    <option value="Albufeira">Albufeira</option>
                                    <option value="Alc&aacute;cer Do Sal">Alc&aacute;cer Do Sal</option>
                                    <option value="Alcanena">Alcanena</option>
                                    <option value="Alcoba&ccedil;a">Alcoba&ccedil;a</option>
                                    <option value="Alcochete">Alcochete</option>
                                    <option value="Alcoutim">Alcoutim</option>
                                    <option value="Alenquer">Alenquer</option>
                                    <option value="Alf&acirc;ndega Da F&eacute;">Alf&acirc;ndega Da F&eacute;</option>
                                    <option value="Alij&oacute;">Alij&oacute;</option>
                                    <option value="Aljezur">Aljezur</option>
                                    <option value="Aljustrel">Aljustrel</option>
                                    <option value="Almada">Almada</option>
                                    <option value="Almeida">Almeida</option>
                                    <option value="Almeirim">Almeirim</option>
                                    <option value="Almod&ocirc;var">Almod&ocirc;var</option>
                                    <option value="Alpiar&ccedil;a">Alpiar&ccedil;a</option>
                                    <option value="Alter Do Ch&atilde;o">Alter Do Ch&atilde;o</option>
                                    <option value="Alvai&aacute;zere">Alvai&aacute;zere</option>
                                    <option value="Alvito">Alvito</option>
                                    <option value="Amadora">Amadora</option>
                                    <option value="Amarante">Amarante</option>
                                    <option value="Amares">Amares</option>
                                    <option value="Anadia">Anadia</option>
                                    <option value="Angra Do Hero&iacute;smo">Angra Do Hero&iacute;smo</option>
                                    <option value="Ansi&atilde;o">Ansi&atilde;o</option>
                                    <option value="Arcos De Valdevez">Arcos De Valdevez</option>
                                    <option value="Arganil">Arganil</option>
                                    <option value="Armamar">Armamar</option>
                                    <option value="Arouca">Arouca</option>
                                    <option value="Arraiolos">Arraiolos</option>
                                    <option value="Arronches">Arronches</option>
                                    <option value="Arruda Dos Vinhos">Arruda Dos Vinhos</option>
                                    <option value="Aveiro">Aveiro</option>
                                    <option value="Avis">Avis</option>
                                    <option value="Azambuja">Azambuja</option>
                                    <option value="Bai&atilde;o">Bai&atilde;o</option>
                                    <option value="Barcelos">Barcelos</option>
                                    <option value="Barrancos">Barrancos</option>
                                    <option value="Barreiro">Barreiro</option>
                                    <option value="Batalha">Batalha</option>
                                    <option value="Beja">Beja</option>
                                    <option value="Belmonte">Belmonte</option>
                                    <option value="Benavente">Benavente</option>
                                    <option value="Bombarral">Bombarral</option>
                                    <option value="Borba">Borba</option>
                                    <option value="Boticas">Boticas</option>
                                    <option value="Braga">Braga</option>
                                    <option value="Bragan&ccedil;a">Bragan&ccedil;a</option>
                                    <option value="Cabeceiras De Basto">Cabeceiras De Basto</option>
                                    <option value="Cadaval">Cadaval</option>
                                    <option value="Caldas Da Rainha">Caldas Da Rainha</option>
                                    <option value="Calheta (madeira)">Calheta (madeira)</option>
                                    <option value="Calheta (s&atilde;o Jorge)">Calheta (s&atilde;o Jorge)</option>
                                    <option value="C&acirc;mara De Lobos">C&acirc;mara De Lobos</option>
                                    <option value="Caminha">Caminha</option>
                                    <option value="Campo Maior">Campo Maior</option>
                                    <option value="Cantanhede">Cantanhede</option>
                                    <option value="Carrazeda De Ansi&atilde;es">Carrazeda De Ansi&atilde;es</option>
                                    <option value="Carregal Do Sal">Carregal Do Sal</option>
                                    <option value="Cartaxo">Cartaxo</option>
                                    <option value="Cascais">Cascais</option>
                                    <option value="Castanheira De P&ecirc;ra">Castanheira De P&ecirc;ra</option>
                                    <option value="Castelo Branco">Castelo Branco</option>
                                    <option value="Castelo De Paiva">Castelo De Paiva</option>
                                    <option value="Castelo De Vide">Castelo De Vide</option>
                                    <option value="Castro Daire">Castro Daire</option>
                                    <option value="Castro Marim">Castro Marim</option>
                                    <option value="Castro Verde">Castro Verde</option>
                                    <option value="Celorico Da Beira">Celorico Da Beira</option>
                                    <option value="Celorico De Basto">Celorico De Basto</option>
                                    <option value="Chamusca">Chamusca</option>
                                    <option value="Chaves">Chaves</option>
                                    <option value="Cinf&atilde;es">Cinf&atilde;es</option>
                                    <option value="Coimbra">Coimbra</option>
                                    <option value="Condeixa-a-nova">Condeixa-a-nova</option>
                                    <option value="Const&acirc;ncia">Const&acirc;ncia</option>
                                    <option value="Coruche">Coruche</option>
                                    <option value="Corvo">Corvo</option>
                                    <option value="Covilh&atilde;">Covilh&atilde;</option>
                                    <option value="Crato">Crato</option>
                                    <option value="Cuba">Cuba</option>
                                    <option value="Elvas">Elvas</option>
                                    <option value="Entroncamento">Entroncamento</option>
                                    <option value="Espinho">Espinho</option>
                                    <option value="Esposende">Esposende</option>
                                    <option value="Estarreja">Estarreja</option>
                                    <option value="Estremoz">Estremoz</option>
                                    <option value="&Eacute;vora">&Eacute;vora</option>
                                    <option value="Fafe">Fafe</option>
                                    <option value="Faro">Faro</option>
                                    <option value="Felgueiras">Felgueiras</option>
                                    <option value="Ferreira Do Alentejo">Ferreira Do Alentejo</option>
                                    <option value="Ferreira Do Z&ecirc;zere">Ferreira Do Z&ecirc;zere</option>
                                    <option value="Figueira Da Foz">Figueira Da Foz</option>
                                    <option value="Figueira De Castelo Rodrigo">Figueira De Castelo Rodrigo</option>
                                    <option value="Figueir&oacute; Dos Vinhos">Figueir&oacute; Dos Vinhos</option>
                                    <option value="Fornos De Algodres">Fornos De Algodres</option>
                                    <option value="Freixo De Espada &Agrave; Cinta">Freixo De Espada &Agrave; Cinta</option>
                                    <option value="Fronteira">Fronteira</option>
                                    <option value="Funchal">Funchal</option>
                                    <option value="Fund&atilde;o">Fund&atilde;o</option>
                                    <option value="Gavi&atilde;o">Gavi&atilde;o</option>
                                    <option value="G&oacute;is">G&oacute;is</option>
                                    <option value="Goleg&atilde;">Goleg&atilde;</option>
                                    <option value="Gondomar">Gondomar</option>
                                    <option value="Gouveia">Gouveia</option>
                                    <option value="Gr&acirc;ndola">Gr&acirc;ndola</option>
                                    <option value="Guarda">Guarda</option>
                                    <option value="Guimar&atilde;es">Guimar&atilde;es</option>
                                    <option value="Horta">Horta</option>
                                    <option value="Idanha-a-nova">Idanha-a-nova</option>
                                    <option value="&Iacute;lhavo">&Iacute;lhavo</option>
                                    <option value="Lagoa (algarve)">Lagoa (algarve)</option>
                                    <option value="Lagoa (s&atilde;o Miguel)">Lagoa (s&atilde;o Miguel)</option>
                                    <option value="Lagos">Lagos</option>
                                    <option value="Lajes Das Flores">Lajes Das Flores</option>
                                    <option value="Lajes Do Pico">Lajes Do Pico</option>
                                    <option value="Lamego">Lamego</option>
                                    <option value="Leiria">Leiria</option>
                                    <option value="Lisboa">Lisboa</option>
                                    <option value="Loul&eacute;">Loul&eacute;</option>
                                    <option value="Loures">Loures</option>
                                    <option value="Lourinh&atilde;">Lourinh&atilde;</option>
                                    <option value="Lous&atilde;">Lous&atilde;</option>
                                    <option value="Lousada">Lousada</option>
                                    <option value="Ma&ccedil;&atilde;o">Ma&ccedil;&atilde;o</option>
                                    <option value="Macedo De Cavaleiros">Macedo De Cavaleiros</option>
                                    <option value="Machico">Machico</option>
                                    <option value="Madalena">Madalena</option>
                                    <option value="Mafra">Mafra</option>
                                    <option value="Maia">Maia</option>
                                    <option value="Mangualde">Mangualde</option>
                                    <option value="Manteigas">Manteigas</option>
                                    <option value="Marco De Canaveses">Marco De Canaveses</option>
                                    <option value="Marinha Grande">Marinha Grande</option>
                                    <option value="Marv&atilde;o">Marv&atilde;o</option>
                                    <option value="Matosinhos">Matosinhos</option>
                                    <option value="Mealhada">Mealhada</option>
                                    <option value="Meda">Meda</option>
                                    <option value="Melga&ccedil;o">Melga&ccedil;o</option>
                                    <option value="M&eacute;rtola">M&eacute;rtola</option>
                                    <option value="Mes&atilde;o Frio">Mes&atilde;o Frio</option>
                                    <option value="Mira">Mira</option>
                                    <option value="Miranda Do Corvo">Miranda Do Corvo</option>
                                    <option value="Miranda Do Douro">Miranda Do Douro</option>
                                    <option value="Mirandela">Mirandela</option>
                                    <option value="Mogadouro">Mogadouro</option>
                                    <option value="Moimenta Da Beira">Moimenta Da Beira</option>
                                    <option value="Moita">Moita</option>
                                    <option value="Mon&ccedil;&atilde;o">Mon&ccedil;&atilde;o</option>
                                    <option value="Monchique">Monchique</option>
                                    <option value="Mondim De Basto">Mondim De Basto</option>
                                    <option value="Monforte">Monforte</option>
                                    <option value="Montalegre">Montalegre</option>
                                    <option value="Montemor-o-novo">Montemor-o-novo</option>
                                    <option value="Montemor-o-velho">Montemor-o-velho</option>
                                    <option value="Montijo">Montijo</option>
                                    <option value="Mora">Mora</option>
                                    <option value="Mort&aacute;gua">Mort&aacute;gua</option>
                                    <option value="Moura">Moura</option>
                                    <option value="Mour&atilde;o">Mour&atilde;o</option>
                                    <option value="Mur&ccedil;a">Mur&ccedil;a</option>
                                    <option value="Murtosa">Murtosa</option>
                                    <option value="Nazar&eacute;">Nazar&eacute;</option>
                                    <option value="Nelas">Nelas</option>
                                    <option value="Nisa">Nisa</option>
                                    <option value="Nordeste">Nordeste</option>
                                    <option value="&Oacute;bidos">&Oacute;bidos</option>
                                    <option value="Odemira">Odemira</option>
                                    <option value="Odivelas">Odivelas</option>
                                    <option value="Oeiras">Oeiras</option>
                                    <option value="Oleiros">Oleiros</option>
                                    <option value="Olh&atilde;o">Olh&atilde;o</option>
                                    <option value="Oliveira De Azem&eacute;is">Oliveira De Azem&eacute;is</option>
                                    <option value="Oliveira De Frades">Oliveira De Frades</option>
                                    <option value="Oliveira Do Bairro">Oliveira Do Bairro</option>
                                    <option value="Oliveira Do Hospital">Oliveira Do Hospital</option>
                                    <option value="Our&eacute;m">Our&eacute;m</option>
                                    <option value="Ourique">Ourique</option>
                                    <option value="Ovar">Ovar</option>
                                    <option value="Pa&ccedil;os De Ferreira">Pa&ccedil;os De Ferreira</option>
                                    <option value="Palmela">Palmela</option>
                                    <option value="Pampilhosa Da Serra">Pampilhosa Da Serra</option>
                                    <option value="Paredes">Paredes</option>
                                    <option value="Paredes De Coura">Paredes De Coura</option>
                                    <option value="Pedr&oacute;g&atilde;o Grande">Pedr&oacute;g&atilde;o Grande</option>
                                    <option value="Penacova">Penacova</option>
                                    <option value="Penafiel">Penafiel</option>
                                    <option value="Penalva Do Castelo">Penalva Do Castelo</option>
                                    <option value="Penamacor">Penamacor</option>
                                    <option value="Penedono">Penedono</option>
                                    <option value="Penela">Penela</option>
                                    <option value="Peniche">Peniche</option>
                                    <option value="Peso Da R&eacute;gua">Peso Da R&eacute;gua</option>
                                    <option value="Pinhel">Pinhel</option>
                                    <option value="Pombal">Pombal</option>
                                    <option value="Ponta Delgada">Ponta Delgada</option>
                                    <option value="Ponta Do Sol">Ponta Do Sol</option>
                                    <option value="Ponte Da Barca">Ponte Da Barca</option>
                                    <option value="Ponte De Lima">Ponte De Lima</option>
                                    <option value="Ponte De Sor">Ponte De Sor</option>
                                    <option value="Portalegre">Portalegre</option>
                                    <option value="Portel">Portel</option>
                                    <option value="Portim&atilde;o">Portim&atilde;o</option>
                                    <option value="Porto">Porto</option>
                                    <option value="Porto De M&oacute;s">Porto De M&oacute;s</option>
                                    <option value="Porto Moniz">Porto Moniz</option>
                                    <option value="Porto Santo">Porto Santo</option>
                                    <option value="P&oacute;voa De Lanhoso">P&oacute;voa De Lanhoso</option>
                                    <option value="P&oacute;voa De Varzim">P&oacute;voa De Varzim</option>
                                    <option value="Povoa&ccedil;&atilde;o">Povoa&ccedil;&atilde;o</option>
                                    <option value="Praia Da Vit&oacute;ria">Praia Da Vit&oacute;ria</option>
                                    <option value="Proen&ccedil;a-a-nova">Proen&ccedil;a-a-nova</option>
                                    <option value="Redondo">Redondo</option>
                                    <option value="Reguengos De Monsaraz">Reguengos De Monsaraz</option>
                                    <option value="Resende">Resende</option>
                                    <option value="Ribeira Brava">Ribeira Brava</option>
                                    <option value="Ribeira De Pena">Ribeira De Pena</option>
                                    <option value="Ribeira Grande">Ribeira Grande</option>
                                    <option value="Rio Maior">Rio Maior</option>
                                    <option value="Sabrosa">Sabrosa</option>
                                    <option value="Sabugal">Sabugal</option>
                                    <option value="Salvaterra De Magos">Salvaterra De Magos</option>
                                    <option value="Santa Comba D&atilde;o">Santa Comba D&atilde;o</option>
                                    <option value="Santa Cruz">Santa Cruz</option>
                                    <option value="Santa Cruz Da Graciosa">Santa Cruz Da Graciosa</option>
                                    <option value="Santa Cruz Das Flores">Santa Cruz Das Flores</option>
                                    <option value="Santa Maria Da Feira">Santa Maria Da Feira</option>
                                    <option value="Santa Marta De Penagui&atilde;o">Santa Marta De Penagui&atilde;o</option>
                                    <option value="Santana">Santana</option>
                                    <option value="Santar&eacute;m">Santar&eacute;m</option>
                                    <option value="Santiago Do Cac&eacute;m">Santiago Do Cac&eacute;m</option>
                                    <option value="Santo Tirso">Santo Tirso</option>
                                    <option value="S&atilde;o Br&aacute;s De Alportel">S&atilde;o Br&aacute;s De Alportel</option>
                                    <option value="S&atilde;o Jo&atilde;o Da Madeira">S&atilde;o Jo&atilde;o Da Madeira</option>
                                    <option value="S&atilde;o Jo&atilde;o Da Pesqueira">S&atilde;o Jo&atilde;o Da Pesqueira</option>
                                    <option value="S&atilde;o Pedro Do Sul">S&atilde;o Pedro Do Sul</option>
                                    <option value="S&atilde;o Roque Do Pico">S&atilde;o Roque Do Pico</option>
                                    <option value="S&atilde;o Vicente">S&atilde;o Vicente</option>
                                    <option value="Sardoal">Sardoal</option>
                                    <option value="S&aacute;t&atilde;o">S&aacute;t&atilde;o</option>
                                    <option value="Seia">Seia</option>
                                    <option value="Seixal">Seixal</option>
                                    <option value="Sernancelhe">Sernancelhe</option>
                                    <option value="Serpa">Serpa</option>
                                    <option value="Sert&atilde;">Sert&atilde;</option>
                                    <option value="Sesimbra">Sesimbra</option>
                                    <option value="Set&uacute;bal">Set&uacute;bal</option>
                                    <option value="Sever Do Vouga">Sever Do Vouga</option>
                                    <option value="Silves">Silves</option>
                                    <option value="Sines">Sines</option>
                                    <option value="Sintra">Sintra</option>
                                    <option value="Sobral De Monte Agra&ccedil;o">Sobral De Monte Agra&ccedil;o</option>
                                    <option value="Soure">Soure</option>
                                    <option value="Sousel">Sousel</option>
                                    <option value="T&aacute;bua">T&aacute;bua</option>
                                    <option value="Tabua&ccedil;o">Tabua&ccedil;o</option>
                                    <option value="Tarouca">Tarouca</option>
                                    <option value="Tavira">Tavira</option>
                                    <option value="Terras De Bouro">Terras De Bouro</option>
                                    <option value="Tomar">Tomar</option>
                                    <option value="Tondela">Tondela</option>
                                    <option value="Torre De Moncorvo">Torre De Moncorvo</option>
                                    <option value="Torres Novas">Torres Novas</option>
                                    <option value="Torres Vedras">Torres Vedras</option>
                                    <option value="Trancoso">Trancoso</option>
                                    <option value="Trofa">Trofa</option>
                                    <option value="Vagos">Vagos</option>
                                    <option value="Vale De Cambra">Vale De Cambra</option>
                                    <option value="Valen&ccedil;a">Valen&ccedil;a</option>
                                    <option value="Valongo">Valongo</option>
                                    <option value="Valpa&ccedil;os">Valpa&ccedil;os</option>
                                    <option value="Velas">Velas</option>
                                    <option value="Vendas Novas">Vendas Novas</option>
                                    <option value="Viana Do Alentejo">Viana Do Alentejo</option>
                                    <option value="Viana Do Castelo">Viana Do Castelo</option>
                                    <option value="Vidigueira">Vidigueira</option>
                                    <option value="Vieira Do Minho">Vieira Do Minho</option>
                                    <option value="Vila De Rei">Vila De Rei</option>
                                    <option value="Vila Do Bispo">Vila Do Bispo</option>
                                    <option value="Vila Do Conde">Vila Do Conde</option>
                                    <option value="Vila Do Porto">Vila Do Porto</option>
                                    <option value="Vila Flor">Vila Flor</option>
                                    <option value="Vila Franca De Xira">Vila Franca De Xira</option>
                                    <option value="Vila Franca Do Campo">Vila Franca Do Campo</option>
                                    <option value="Vila Nova Da Barquinha">Vila Nova Da Barquinha</option>
                                    <option value="Vila Nova De Cerveira">Vila Nova De Cerveira</option>
                                    <option value="Vila Nova De Famalic&atilde;o">Vila Nova De Famalic&atilde;o</option>
                                    <option value="Vila Nova De Foz C&ocirc;a">Vila Nova De Foz C&ocirc;a</option>
                                    <option value="Vila Nova De Gaia">Vila Nova De Gaia</option>
                                    <option value="Vila Nova De Paiva">Vila Nova De Paiva</option>
                                    <option value="Vila Nova De Poiares">Vila Nova De Poiares</option>
                                    <option value="Vila Pouca De Aguiar">Vila Pouca De Aguiar</option>
                                    <option value="Vila Real">Vila Real</option>
                                    <option value="Vila Real De Santo Ant&oacute;nio">Vila Real De Santo Ant&oacute;nio</option>
                                    <option value="Vila Velha De R&oacute;d&atilde;o">Vila Velha De R&oacute;d&atilde;o</option>
                                    <option value="Vila Verde">Vila Verde</option>
                                    <option value="Vila Vi&ccedil;osa">Vila Vi&ccedil;osa</option>
                                    <option value="Vimioso">Vimioso</option>
                                    <option value="Vinhais">Vinhais</option>
                                    <option value="Viseu">Viseu</option>
                                    <option value="Vizela">Vizela</option>
                                    <option value="Vouzela">Vouzela</option>
                                </select>
                                <label :class="{ 'select-placeholder' : !city }">
                                    Cidade
                                </label>
                            </div>
                        </validation-provider>
                    </div>
                    <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                        <div class="mb-2">
                            <div class="form-check p-0">
                                <label class="form-check-label" :class="classes">
                                    <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                    <span class="checkmark"></span>
                                    <span class="tw-text-black" style="font-size: 10px;">Autorizo a {{ company }} a utilizar os meus dados para ser contactado segundo a sua <a href="https://www.minisom.pt/politica-de-privacidade" target="_blank"><u>política de privacidade</u></a>.</span>
                                </label>
                            </div>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: true } }" v-slot="{ classes }">
                        <div class="mb-2">
                            <div class="form-check p-0">
                                <label class="form-check-label" :class="classes">
                                    <input class="form-check-input" type="checkbox" value="true" v-model="marketing">
                                    <span class="checkmark"></span>
                                    <span class="tw-text-black" style="font-size: 10px;">Desejo receber informação e ofertas – marketing direto - da Minisom (Amplifon Portugal, S.A.)</span>
                                </label>
                            </div>
                        </div>
                    </validation-provider>
                    <div class="tw-text-center tw-mt-4">
                        <button
                            type="submit"
                            class="btn-cta"
                            id="submit"
                            :disabled="formLoading"
                        >
                            Receber
                        </button>
                    </div>
                </div>
                <div class="bullets">
                    <div v-for="step in steps" :key="step" :class="{ 'active' : formStep >= step }"></div>
                </div>
            </fieldset>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';

export default {
    name: 'FormComponent',
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            city: '',
            page: '30dias.minisom.aparelho.pt',
            marketing: false,

            formStep: 1,
            steps: 4,
            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                fullName: this.fullName,
                phone: this.phone,
                email: this.email,
                city: this.city,
                page: this.page,
                marketing: this.marketing,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                    gtag('event', 'conversion', { send_to: 'AW-986637511/K6oWCP2z9qEBEMfJu9YD' });
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'já registado';
                    }
                    if (error.response.data.errors.phone) {
                        error.response.data.errors.phone = 'já registado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/partials/_variables.scss";

.form {
    padding-bottom: 40px;

    fieldset {

        @screen lg {
            width: 640px;
        }

        .question {
            @apply tw-font-bold tw-text-black tw-text-center tw-mx-auto tw-block;
            font-size: 22px;
            line-height: 33px;

            @screen lg {
                font-size: 26px;
            }
        }

        .step {
            @apply tw-pt-4;

            @screen lg {
                @apply tw-pt-8;
            }

            .options {
                @apply tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3;

                @screen lg {
                    @apply tw-flex-row tw-mx-auto tw-gap-6;
                    width: 640px;
                }

                >div {
                    @apply tw-bg-white tw-text-black tw-font-bold tw-text-center tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-text-xl tw-relative;
                    border-radius: 20px;
                    padding: 25px 0;
                    border: solid 2px $white;
                    transition: border 0.3s ease-in-out;
                    box-shadow: $box-shadow;
                    width: 300px !important;

                    &:hover {
                        @apply tw-text-white tw-transition-none;
                        background-color: $main_color;
                        border: solid 2px $main_color;

                        &::before {
                            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='14.553' viewBox='0 0 20 14.553'%3E%3Cpath d='M19.414,58.6,8.863,69.155a2,2,0,0,1-2.831,0L.586,63.708a2,2,0,0,1,2.83-2.831l4.032,4.032,9.135-9.135A2,2,0,0,1,19.414,58.6Z' transform='translate(0 -55.188)' fill='%23fff'/%3E%3C/svg%3E");
                            @apply tw-absolute;
                            top: 45%;
                            transform: translateY(-50%);
                            left: 20px;
                            width: 20px;
                            height: 14.55px;
                        }
                    }
                }
            }
        }

        .bullets {
            @apply tw-flex tw-items-center tw-justify-center tw-gap-2 tw-pt-8;

            >div {
                @apply tw-rounded-full tw-w-3 tw-h-3;
                background-color: rgba($main_color, .15);

                &.active {
                    background-color: $main_color;
                }
            }
        }
    }
}
</style>
